import React from 'react'
import { Trans } from '@lingui/macro'

import classes from './Description.module.scss'

export const Description = () => {
  return (
    <p className={classes.Description}>
      <Trans>
        you have been refreshing too quickly. Give us a moment to reconnect you
        to the game.
      </Trans>
    </p>
  )
}
